import React from "react";
import { CmpAskcoachfab } from "../../components/CmpAskcoachfab";
import { CmpWorkoutcard } from "../../components/CmpWorkoutcard";
import { MobilityMiniCard } from "../../components/MobilityMiniCard";
import "./style.css";

export const WorkoutPeekModal = () => {
  return (
    <div className="workout-peek-modal" data-model-id="2265:2482">
      <div className="rectangle-wrapper">
        <div className="rectangle" />
      </div>

      <CmpWorkoutcard className="design-component-instance-node" state="live" />
      <div className="overlap-group-wrapper">
        <div className="overlap-group-2">
          <div className="PD-fplaceholder-wrapper">
            <div className="PD-fplaceholder" />
          </div>

          <p className="workout-summary">
            Workout summary (35 Words)
            <br />
            Workout summary (35 Words)
            <br />
            Workout summary (35 Words)
          </p>
        </div>
      </div>

      <div className="cmp-mobilityminicard">
        <MobilityMiniCard
          className="mobility-mini-card-instance"
          clipPathGroup="/img/clip-path-group-2.png"
          elementMorningStretchClassName="mobility-mini-card-4"
          frameClassName="mobility-mini-card-2"
          img="/img/vector-5.svg"
          mobilityMiniCardClassName="mobility-mini-card-3"
          spanClassName="mobility-mini-card-5"
          spanClassNameOverride="mobility-mini-card-6"
          vector="/img/vector-4.svg"
        />
      </div>

      <CmpAskcoachfab className="design-component-instance-node" />
    </div>
  );
};
